<template>
    <div id="app">
        <docs-content></docs-content>
        <vue-progress-bar></vue-progress-bar>
    </div>
</template>
<script>
import docsContent from './components/content.vue'
export default {
    components: {
        docsContent
    }
}
</script>



/** WEBPACK FOOTER **
 ** App.vue?144e3796
 **/